<template>
    <div id="custom-multiselect" :class="{ 'show-feedback': isInvalid }">
        <vue-multiselect
            :id="id"
            v-model="model"
            label="label"
            trackBy="value"
            :options="options"
            openDirection="bottom"
            :multiple="true"
            :disabled="disabled"
            :hideSelected="true"
            :class="{ 'is-valid': isValid, 'is-invalid': isInvalid }"
            :placeholder="getPlaceholder"
            :tagPlaceholder="$t('form.multiselect.tagPlaceholder')"
            :selectLabel="$t('form.multiselect.selectLabel')"
            :selectGroupLabel="$t('form.multiselect.selectGroupLabel')"
            :selectedLabel="$t('form.multiselect.selectedLabel')"
            :deselectLabel="$t('form.multiselect.deselectLabel')"
            :deselectGroupLabel="$t('form.multiselect.deselectGroupLabel')"
            @input="changedSelectedValue()"
            group-values="values"
            group-label="label"
            :group-select="false"
        ></vue-multiselect>
    </div>
</template>

<script>
import i18n from '@/i18n'
import VueMultiselect from 'vue-multiselect'

export default {
    name: 'MultiselectGroup',
    components: {
        VueMultiselect,
    },
    props: ['id', 'options', 'state', 'selected', 'placeholder', 'disabled'],
    data() {
        return {
            model: null,
        }
    },
    computed: {
        isValid() {
            return this.state && this.state !== null
        },
        isInvalid() {
            return !this.state && this.state !== null
        },
        getPlaceholder() {
            return this.placeholder || i18n.t('form.placeholder.select')
        },
    },
    watch: {
        selected(value) {
            this.model = value
        },
    },
    methods: {
        changedSelectedValue() {
            this.$emit('changeValue', this.model)
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';
</style>

<style>
.show-feedback ~ .invalid-feedback {
    display: block !important;
}
</style>
